(() => {
  const bandMap = {
    1: { key: 'ultra-light', name: 'Ultra Light', lbs: 10, kg: '4.5' },
    2: { key: 'light', name: 'Light', lbs: 20, kg: '11' },
    3: { key: 'medium', name: 'Medium', lbs: 30, kg: '13.5' },
    4: { key: 'heavy', name: 'Heavy', lbs: 40, kg: '18' },
    5: { key: 'extreme', name: 'Extreme', lbs: 50, kg: '22.7' },
    6: { key: 'ultra', name: 'Ultra', lbs: 60, kg: '27' },
    7: { key: 'ultra-plus', name: 'Ultra Plus', lbs: 70, kg: '32' },
    8: { key: 'mega', name: 'Mega', lbs: 80, kg: '37' },
    9: { key: 'mega-plus', name: 'Mega Plus', lbs: 90, kg: '41' },
  };

  const setLabels = {
    pro: 'Pro Set',
    ultra: 'Ultra Set',
    mega: 'Mega Set',
  };

  const matrixRows = {
    pro: [
      [10, [1]],
      [20, [2]],
      [30, [3]],
      [40, [4]],
      [50, [5]],
      [60, [1, 5]],
      [70, [2, 5]],
      [80, [3, 5]],
      [90, [4, 5]],
      [100, [1, 4, 5]],
      [110, [2, 4, 5]],
      [120, [3, 4, 5]],
      [130, [1, 3, 4, 5]],
      [140, [2, 3, 4, 5]],
      [150, [1, 2, 3, 4, 5]],
    ],
    ultra: [
      [10, [1]],
      [20, [2]],
      [30, [3]],
      [40, [4]],
      [50, [5]],
      [60, [6]],
      [70, [7]],
      [80, [1, 7]],
      [90, [2, 7]],
      [100, [3, 7]],
      [110, [4, 7]],
      [120, [5, 7]],
      [130, [1, 6, 7]],
      [140, [2, 6, 7]],
      [150, [1, 2, 3, 4, 5]],
      [160, [3, 6, 7]],
      [170, [4, 6, 7]],
      [180, [5, 6, 7]],
      [190, [1, 5, 6, 7]],
      [200, [2, 5, 6, 7]],
      [210, [3, 5, 6, 7]],
      [220, [4, 5, 6, 7]],
      [230, [1, 4, 5, 6, 7]],
      [240, [2, 4, 5, 6, 7]],
      [250, [3, 4, 5, 6, 7]],
      [260, [1, 3, 4, 5, 6, 7]],
      [270, [2, 3, 4, 5, 6, 7]],
      [280, [1, 2, 3, 4, 5, 6, 7]],
    ],
    mega: [
      [10, [1]],
      [20, [2]],
      [30, [3]],
      [40, [4]],
      [50, [5]],
      [60, [6]],
      [70, [7]],
      [80, [8]],
      [90, [9]],
      [100, [1, 9]],
      [110, [2, 9]],
      [120, [3, 9]],
      [130, [4, 9]],
      [140, [5, 9]],
      [150, [1, 2, 3, 4, 5]],
      [160, [7, 9]],
      [170, [8, 9]],
      [180, [1, 8, 9]],
      [190, [2, 8, 9]],
      [200, [3, 8, 9]],
      [210, [4, 8, 9]],
      [220, [5, 8, 9]],
      [230, [6, 8, 9]],
      [240, [7, 8, 9]],
      [250, [1, 7, 8, 9]],
      [260, [2, 7, 8, 9]],
      [270, [3, 7, 8, 9]],
      [280, [1, 2, 3, 4, 5, 6, 7]],
      [290, [5, 7, 8, 9]],
      [300, [6, 7, 8, 9]],
      [310, [1, 6, 7, 8, 9]],
      [320, [2, 6, 7, 8, 9]],
      [330, [3, 6, 7, 8, 9]],
      [340, [4, 6, 7, 8, 9]],
      [350, [5, 6, 7, 8, 9]],
      [360, [1, 5, 6, 7, 8, 9]],
      [370, [2, 5, 6, 7, 8, 9]],
      [380, [3, 5, 6, 7, 8, 9]],
      [390, [4, 5, 6, 7, 8, 9]],
      [400, [1, 4, 5, 6, 7, 8, 9]],
      [410, [2, 4, 5, 6, 7, 8, 9]],
      [420, [3, 4, 5, 6, 7, 8, 9]],
      [430, [1, 3, 4, 5, 6, 7, 8, 9]],
      [440, [2, 3, 4, 5, 6, 7, 8, 9]],
      [450, [1, 2, 3, 4, 5, 6, 7, 8, 9]],
    ],
  };

  const renderResistance = (lbs, kg) => `
    <span class="hpg-choosing-bands__guide-lbs">${lbs}</span>
    <span class="hpg-choosing-bands__guide-stat-unit">lbs</span>
    <span class="hpg-choosing-bands__guide-kg">(${kg} kg)</span>
  `;

  const renderPill = (bandId) => {
    const band = bandMap[bandId];
    return `<span class="hpg-choosing-bands__guide-pill hpg-choosing-bands__guide-pill--${band.key}">${band.name} ${band.lbs}lb</span>`;
  };

  const renderMatrixRows = (setKey) =>
    matrixRows[setKey]
      .map(([lbs, bandIds]) => {
        const totalKg = bandIds
          .reduce((sum, bandId) => sum + Number.parseFloat(bandMap[bandId].kg), 0)
          .toFixed(1)
          .replace(/\.0$/, '');

        return `
          <tr>
            <td>${renderResistance(lbs, totalKg)}</td>
            <td>${bandIds.map(renderPill).join('')}</td>
          </tr>
        `;
      })
      .join('');

  const updateMatrix = (root, setKey) => {
    const tbody = root.querySelector('[data-hcb-matrix-body]');
    const resultCount = root.querySelector('[data-hcb-matrix-count]');

    if (!tbody || !resultCount) return;

    tbody.innerHTML = renderMatrixRows(setKey);
    resultCount.innerHTML = `Showing <strong>${matrixRows[setKey].length} resistance levels</strong> for ${setLabels[setKey]}`;
  };

  const initTabs = (root) => {
    const buttons = root.querySelectorAll('[data-hcb-tab]');
    const panels = root.querySelectorAll('[data-hcb-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-hcb-tab');

        buttons.forEach((item) => item.classList.remove('is-active'));
        panels.forEach((panel) => panel.classList.remove('is-active'));

        button.classList.add('is-active');
        const nextPanel = root.querySelector(`[data-hcb-panel="${target}"]`);
        if (nextPanel) nextPanel.classList.add('is-active');
      });
    });
  };

  const initFilters = (root) => {
    const filters = root.querySelectorAll('[data-hcb-set]');
    if (!filters.length) return;

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const setKey = filter.getAttribute('data-hcb-set');

        filters.forEach((item) => item.classList.remove('is-active'));
        filter.classList.add('is-active');
        updateMatrix(root, setKey);
      });
    });
  };

  const initChoosingBands = (root) => {
    if (root.dataset.hcbInitialized === 'true') return;

    root.dataset.hcbInitialized = 'true';
    initTabs(root);
    initFilters(root);
    updateMatrix(root, 'pro');
  };

  const boot = () => {
    document.querySelectorAll('[data-hpg-choosing-bands-root]').forEach(initChoosingBands);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
